// eslint-disable-next-line no-magic-numbers
export const imageSizes = [16, 32, 48, 57, 64, 96, 128, 192, 200, 220, 256, 384, 512, 640, 768, 1000, 1024];

export const DEFAULT_IMAGE_WIDTH = 640;
export const DEFAULT_IMAGE_HEIGHT = 480;
export const DEFAULT_IMAGE_QUALITY = 75;
export const DITHERED_IMAGE_QUALITY = 60;

const nearestValue = (arr, val) => arr.reduce((reduction, element) =>
  (Math.abs(reduction) > Math.abs(element - val) ? element - val : reduction), Infinity) + val;

export const ditheredImageSrc = (src, width = DEFAULT_IMAGE_WIDTH) =>
  `/_next/image?url=${src}&w=${nearestValue(imageSizes, width)}&q=${DITHERED_IMAGE_QUALITY}`;
